import { Link } from "react-router-dom";
import { BACKEND_URL } from "../lib/api";
import RoomScene from "./RoomScene";
import { useRoomScenes } from "../lib/roomScenes";

const resolveImg = (url) =>
  url && url.startsWith("/api") ? `${BACKEND_URL}${url}` : url;

// `inSitu` toggle (v1.28): renders the artwork composited into a rotating
// room scene instead of the raw thumbnail. Cards cycle deterministically by
// index so the same artwork always lands in the same room (avoids layout
// shift on re-render) and the grid feels like a curated magazine spread.
export const ArtworkCard = ({ artwork, aspect = "square", inSitu = false, sceneIndex = 0 }) => {
  const ROOM_SCENES = useRoomScenes();
  const aspectClass =
    aspect === "tall" ? "aspect-[4/5]" : aspect === "wide" ? "aspect-[5/3]" : "aspect-square";
  const imgUrl = resolveImg(artwork.image_url);
  const scene = ROOM_SCENES.length ? ROOM_SCENES[sceneIndex % ROOM_SCENES.length] : null;
  return (
    <Link
      to={`/artwork/${artwork.id}`}
      data-testid={`artwork-card-${artwork.id}`}
      className="block group"
    >
      <div className={`hover-zoom-wrap relative ${aspectClass} bg-[#F2EDE5]`}>
        {inSitu && scene ? (
          <div className="hover-zoom w-full h-full">
            <RoomScene
              artworkUrl={imgUrl}
              artworkAlt={artwork.title}
              scene={scene}
              frameId="oak"
              className="w-full h-full"
            />
          </div>
        ) : (
          <img
            src={imgUrl}
            alt={`${artwork.title}${artwork.medium ? ` — ${artwork.medium.toLowerCase()}` : ""}${artwork.artist_name ? ` by ${artwork.artist_name}` : ""}${artwork.country ? `, ${artwork.country}` : ""}`}
            className="hover-zoom w-full h-full object-cover"
            loading="lazy"
          />
        )}
        {artwork.sold && (
          <span className="absolute top-3 left-3 label-eyebrow bg-[#1E3A8A] text-[#F4C430] px-2 py-1 z-10">
            Sold
          </span>
        )}
      </div>
      <div className="mt-4 flex items-start justify-between gap-4">
        <div className="min-w-0">
          <p className="label-eyebrow text-[#1E3A8A] truncate">{artwork.medium} · {artwork.country || "Africa"}</p>
          <h3 className="font-serif-display text-xl md:text-2xl mt-1 leading-tight text-[#111] truncate">{artwork.title}</h3>
          <p className="text-sm text-[#555] mt-1 truncate">{artwork.artist_name}</p>
          {artwork.art_center_name && (
            <p className="text-xs text-[#1E3A8A]/80 mt-0.5 truncate" data-testid={`artwork-center-${artwork.id}`}>
              via {artwork.art_center_name}
            </p>
          )}
        </div>
        <p className="font-mono-aam text-sm whitespace-nowrap text-[#1E3A8A]">
          ${Number(artwork.price).toLocaleString()}
        </p>
      </div>
    </Link>
  );
};
